import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx("optgroup", _extends({}, props, {
  ref: ref
})));